import React from 'react';
import Button, { BOOKING_HREF } from '../Button/Button';
import './CTABanner.css';
import shapeFooter from '../../assets/waves/Shape 4 Footer.svg';
import forestFooter from '../../assets/waves/Footer illustration.svg';

const CTABanner = () => (
  <section className="cta-banner" id="contact">
    <div className="cta-banner__inner site-rail site-rail--wide">
      <h2 className="cta-banner__heading">Let's talk about your outdoor space.</h2>
      <p className="cta-banner__body">Book a free 30-minute consultation. No pressure, no commitment. Just a real conversation about what you want and what's possible.</p>
      <div className="cta-banner__actions">
        <Button variant="tertiary" href={BOOKING_HREF}>Book a Free Consultation</Button>
        <span className="cta-banner__note">No commitment · Responds within 24 hours</span>
      </div>
    </div>
    <div className="cta-banner__art" aria-hidden="true">
      <img src={shapeFooter} alt="" className="cta-banner__shape" />
      <div className="cta-banner__forest-wrap">
        <img src={forestFooter} alt="" className="cta-banner__forest" />
      </div>
    </div>
  </section>
);

export default CTABanner;
